import { createClient } from '@/lib/supabase/client';

export class ApiError extends Error {
  status: number;
  statusText: string;

  constructor(response: Response, message?: string) {
    super(message || `API error: ${response.status} ${response.statusText}`);
    this.name = 'ApiError';
    this.status = response.status;
    this.statusText = response.statusText;
  }
}

/**
 * Authenticated fetch wrapper that automatically includes the Supabase access token.
 * Throws ApiError for non-2xx responses.
 */
export async function apiFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const supabase = createClient();
  const { data: { session } } = await supabase.auth.getSession();

  const headers = new Headers(init?.headers);

  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`);
  }

  const response = await fetch(input, {
    ...init,
    headers,
  });

  if (!response.ok) {
    let message: string | undefined;
    try {
      const body = await response.clone().json();
      message = body.message || body.error;
    } catch {
      // Response body is not JSON
    }
    throw new ApiError(response, message);
  }

  return response;
}
